/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {prepareEmailUpdate} from '../api'

export const useMutationPrepareEmailUpdate = createReactQueryMutationHook('prepareEmailUpdate', prepareEmailUpdate)
